<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8">
    <CentralHeader
      title="What's Included"
      subtitle="We've included lots in our UGM bundle. Here's a more in depth look at what you'll be getting in our different packs"
    ></CentralHeader>
    <submission-spinner v-if="collections.length === 0"></submission-spinner>
    <div class="space-y-12">
      <Card v-for="collection in collections" :key="collection._id">
        <div class="px-16 py-8">
          <div>
            <h2 class="text-2xl font-semibold text-center ">
              {{ collection.name }}
            </h2>
            <h3 class="text-lg  text-center">
              {{ collection.subtitle }}
            </h3>
            <div
              class="grid grid-cols-5 gap-4 mt-8 justify-center items-center"
            >
              <div v-for="item in collection.items" :key="item.key">
                <img :src="urlFor(item.preview)" alt="" class="rounded" />
              </div>
            </div>
          </div>
        </div>
        <div class="border-t-2 border-vectric p-6 text-center font-semibold">
          <div class="text-center">
            All clipart compatible with the following products
          </div>
          <div class="mt-4 flex justify-center">
            <CompatibilityBlock
              :compatibility-array="collection.productCompatibility"
            />
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import { sanityClient } from "../utils/sanity";
import CentralHeader from "../components/shared/CentralHeader";
import SubmissionSpinner from "../components/SubmissionSpinner";
import sanityImageBuilder from "../utils/sanityImageBuilder";
import CompatibilityBlock from "../components/whatsIncluded/CompatibilityBlock";
import Card from "../components/shared/Card.vue";

export default {
  name: "WhatsIncluded",
  components: { Card, CompatibilityBlock, SubmissionSpinner, CentralHeader },
  data() {
    return {
      collections: []
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      const queryString =
        "*[_type == 'whatsIncludedCollection'] { productCompatibility[]->{...}, ...}";
      sanityClient
        .fetch(queryString)
        .then(res => {
          console.log(res);
          this.collections = res;
        })
        .catch(function(err) {
          console.error(err);
        });
    },
    urlFor(imgObject) {
      return sanityImageBuilder
        .image(imgObject)
        .height(200)
        .url();
    }
  }
};
</script>

<style scoped></style>
